<!--
  Header segue o padrão do `event-creator-modal`: toolbar light (sem primary
  saturado), título simples + context-bar separada DENTRO do ion-header com
  thumb da quadra + meta (data + horário). Padrão padrão dos modais
  "produtivos" do sistema (contraste com agenda-legend-modal, que é
  informativo e usa toolbar primary).
-->
<ion-header class="ion-no-border">
  <ion-toolbar class="modal-toolbar">
    <ion-title>Horário especial</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Fechar">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="context-bar">
    @if (payload.courtImage) {
      <div class="context-thumb">
        <img [src]="payload.courtImage" [alt]="payload.courtName ?? 'Quadra'" loading="lazy" />
      </div>
    } @else {
      <div class="context-thumb context-thumb--fallback">
        <ion-icon name="tennisball-outline"></ion-icon>
      </div>
    }
    <div class="context-info">
      <div class="context-court notranslate">{{ payload.courtName ?? 'Quadra ' + payload.courtId }}</div>
      <div class="context-meta">
        <ion-icon name="calendar-outline" aria-hidden="true"></ion-icon>
        <span>{{ dateLabel() }}</span>
        <span class="context-dot">•</span>
        <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
        <span>Início {{ payload.slotTime }}</span>
      </div>
    </div>
  </div>
</ion-header>

<ion-content class="modal-content">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <!--
      Duração — primeira coisa pra editar porque define quando o slot acaba.
      Combo de chips rápidos (durações comuns) + input numérico pra valores
      custom. `endTimeLabel` reage live à mudança (computed via signal).
    -->
    <div class="qc-field-group">
      <label class="qc-field-label">Duração</label>
      <div class="qc-duration-chips" role="radiogroup" aria-label="Duração rápida">
        @for (dur of durationOptions; track dur) {
          <button
            type="button"
            class="qc-chip"
            [class.is-active]="form.controls.durationMin.value === dur"
            (click)="form.controls.durationMin.setValue(dur)"
          >
            {{ dur }} min
          </button>
        }
      </div>
      <div class="qc-duration-custom">
        <ion-input
          class="qc-duration-input"
          formControlName="durationMin"
          type="number"
          min="5"
          max="240"
          inputmode="numeric"
          aria-label="Duração em minutos"
        ></ion-input>
        <span class="qc-duration-suffix">min · termina às <strong>{{ endTimeLabel() }}</strong></span>
      </div>

      <!--
        Aviso de conflito — apenas quando o intervalo proposto sobrepõe
        algum evento existente do dia/quadra. Mostra qual slot conflita
        pra o user saber o que ajustar (encurtar duração, escolher outro
        horário). Backend também valida — isso é defesa em profundidade
        + UX (feedback instantâneo, sem network roundtrip).
      -->
      @if (conflictEvent(); as conflict) {
        <div class="qc-conflict" role="alert">
          <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
          <div>
            <strong>Conflito de horário</strong>
            <span>Já existe horário reservado das <strong>{{ conflict.start }}</strong> às <strong>{{ conflict.end }}</strong>. Diminua a duração ou escolha outro horário.</span>
          </div>
        </div>
      }
    </div>

    <!-- Esporte -->
    <ion-item class="qc-field" lines="full">
      <ion-label position="stacked">Esporte *</ion-label>
      <ion-select
        formControlName="sportId"
        placeholder="Selecione o esporte"
        interface="action-sheet"
      >
        @for (sport of sports(); track sport.id) {
          <ion-select-option [value]="sport.id">{{ sport.name }}</ion-select-option>
        }
      </ion-select>
    </ion-item>
    @if (form.controls.sportId.invalid && form.controls.sportId.touched) {
      <p class="qc-error">Selecione um esporte</p>
    }

    <!--
      Preço — `maskBrlCurrencyFormat` formata o valor digitado em BRL ao vivo.
      A diretiva aceita um `number` como input inicial (não atributo flag). Pra
      pré-preencher com a sugestão usamos `payload.suggestedPrice`; quando
      não há sugestão (undefined), `$any(undefined)` desliga o type-check do
      template e a directive ignora (else-branch do ngOnInit dela).
    -->
    <ion-item class="qc-field" lines="full">
      <ion-label position="stacked">Preço *</ion-label>
      <ion-input
        formControlName="price"
        placeholder="R$ 0,00"
        [maskBrlCurrencyFormat]="payload.suggestedPrice ?? $any(undefined)"
        inputmode="decimal"
      ></ion-input>
    </ion-item>

    <!-- Capacidade (max players) — relevante pra HORARIO_COMPARTILHADO -->
    <ion-item class="qc-field" lines="full">
      <ion-label position="stacked">Vagas</ion-label>
      <ion-input
        formControlName="maxPlayers"
        type="number"
        min="1"
        max="20"
      ></ion-input>
    </ion-item>

    <!-- Motivo (opcional visualmente, default "Horário estendido") -->
    <ion-item class="qc-field" lines="full">
      <ion-label position="stacked">Motivo</ion-label>
      <ion-input
        formControlName="reason"
        placeholder="Horário estendido"
      ></ion-input>
    </ion-item>
  </form>
</ion-content>

<ion-footer class="ion-no-border qc-footer">
  <ion-toolbar>
    <div class="qc-footer__buttons">
      <ion-button fill="clear" color="medium" (click)="dismiss()">
        Cancelar
      </ion-button>
      <ion-button
        fill="solid"
        color="primary"
        (click)="submit()"
        [disabled]="form.invalid || isSubmitting() || hasConflict()"
      >
        @if (isSubmitting()) {
          <ion-spinner name="dots" slot="start"></ion-spinner>
        }
        Criar horário
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
